import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import RequestImage from "../assets/Images/request_submitted.png";
import {
  Modal,
  Box,
  Stack,
  Typography,
  Button,
  CircularProgress,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { confirmBooking } from "../apis";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const PaymentSuccess = () => {
  const [serviceProviderName, setServiceProviderName] = useState("");
  const [loading, setLoading] = useState(true);
  let { requestId, currentRequestId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const setData = async () => {
      const response = await confirmBooking({
        currentRequestId: currentRequestId,
        requestId: requestId,
      });
      setServiceProviderName(
        response.data.currentRequestData.serviceProviderName
      );
      setLoading(false);
    };

    setData();
  }, []);

  const bookingHandler = () => {
    navigate("/my-bookings");
  };

  if (loading) {
    return (
      <>
        <Navbar />
        <Box
          sx={{ display: "flex" }}
          justifyContent="center"
          alignItems="center"
          style={{ height: "100vh" }}
        >
          <CircularProgress disableShrink />
        </Box>
      </>
    );
  } else {
    return (
      <>
        <Navbar />
        <Modal
          open={true}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Stack spacing={2} justifyContent="center" alignItems="center">
              <img
                src={RequestImage}
                alt="MenuIcon"
                style={{ width: "300px", height: "300px" }}
              />
              <Typography style={{ fontWeight: "bold" }}>
                Booking confirmed
              </Typography>
              <Typography style={{ textAlign: "center" }}>
                Your booking confirmed with {serviceProviderName}. Thank you for
                trusting us.
              </Typography>
              <Button
                variant="contained"
                className="primary-button"
                style={{ textTransform: "capitalize" }}
                onClick={bookingHandler}
              >
                View Booking
              </Button>
            </Stack>
          </Box>
          {/* <div>
            <img src={RequestImage} alt="MenuIcon" />
          </div> */}
        </Modal>
      </>
    );
  }
};

export default PaymentSuccess;
